<div class="container">
  <div class="row">
    <div class="col-md-12 my-5 py-3 px-3">
      <div class="debug px-5 py-5">
        <h4>Condiciones de uso</h4>
        <h6>
          ¡Te damos la bienvenida a Aplícate!
        </h6>
        <p>
          Aplícate desarrolla servicios que permiten que las personas se conecten, creen comunidades y hagan crecer su
          negocio y/o servicio. Estas Condiciones rigen el uso de Aplícate, excepto cuando indiquemos expresamente que
          se aplican otras condiciones (y no éstas).
        </p>
        <p>
          No vendemos tus datos personales pero si compartimos información que te identifica directamente (como el
          nombre de tu negocio o servicio, teléfono, dirección y fotografías del mismo) con los usuarios de Aplícate.
        </p>
        <p>
          Nuestra Política de datos explica cómo recopilamos y usamos tus datos personales para determinar el contenido
          que los usuarios podrán ver.
        </p>
        <h4>Los servicios que proporcionamos</h4>
        <p>
          Te conectamos con las personas y negocios que te puedan interesar.
          Te ayudamos a encontrar y contactar personas que ofrecen un servicio o un negocio mediante la aplicación
          Aplicate.

        </p>
        <p>
          Investigamos formas de mejorar nuestros servicios.
          Realizamos investigaciones para desarrollar, probar y mejorar la aplicación. Esto incluye analizar los datos
          que tenemos sobre nuestros usuarios y entender cómo usan las personas el servicio que Aplícate ofrece, por
          ejemplo, probando funciones nuevas y solucionando problemas relacionados con ella.

        </p>
        <h6>Tus compromisos con Aplícate y nuestra comunidad</h6>
        <p>

          Ofrecemos estos servicios tanto a ti como a otras personas para cumplir nuestra misión. A cambio, necesitamos
          que asumas los siguientes compromisos:

        </p>
        <h4>
          Quién puede usar Aplícate
        </h4>
        <p>

          Cuando las personas asumen la responsabilidad del contenido, nuestra comunidad es más segura y transparente.
          Por este motivo, debes cumplir con lo siguiente:

        </p>
        <ul>
          <li>
            Utiliza el mismo nombre que usas en la vida cotidiana.
          </li>
          <li>
            Brinda información precisa sobre ti.
          </li>
          <li>
            Crea solo una cuenta (propia).
          </li>
          <li>
            No compartas tu contraseña, concedas acceso a tu cuenta de Aplícate a otros ni transfieras a nadie tu
            cuenta.
            Intentamos que todos puedan usar Aplícate, pero hay algunas excepciones. No podrás usar la plataforma en los
            siguientes casos:
          </li>
          <li>
            Eres un delincuente condenado por delitos sexuales.
          </li>
          <li>
            Inhabilitamos previamente tu cuenta porque incumpliste nuestras condiciones o políticas
          </li>
          <li>
            Las leyes aplicables prohíben que utilices la aplicación.
          </li>
        </ul>
        <h4>
          Qué contenido puedes compartir y qué actividades puedes realizar en Aplícate
        </h4>
        <p>
          Queremos que la gente use Aplícate para compartir contenido que le resulte beneficioso a la comunidad, pero
          sin poner en peligro la seguridad y el bienestar de otras personas ni perjudicar la integridad de nuestra
          comunidad. Por lo tanto, aceptas no participar en las conductas que se describen a continuación (ni ayudar o
          apoyar a otros para que lo hagan).
        </p>
        <ol>
          <li>
            No puedes usar Aplícate para realizar actividades o compartir contenido:
            <ul>
              <li>
                Que incumplan estas Condiciones, nuestras políticas de comunidad y otras condiciones y políticas que
                rijan el uso de Aplícate.
              </li>
              <li>
                Que sean ilegales, engañosos, discriminatorios o fraudulentos.
              </li>
              <li>
                Que infrinjan los derechos de otras personas, incluidos los derechos de propiedad intelectual.
              </li>
            </ul>
          </li>
          <li>
            No puedes realizar actividades que puedan impedir, sobrecargar o afectar el correcto funcionamiento de
            Aplícate, o afectar su aspecto.
          </li>
        </ol>
        <h4>
          Podemos eliminar o restringir el acceso a contenido que infrinja estas disposiciones.
        </h4>
        <p>
          Si eliminamos contenido que compartiste debido a una infracción de nuestras normas comunitarias, te avisaremos
          y explicaremos por medio de correo electrónico los motivos por los cuales se elimino el contenido. Para
          contribuir con nuestra comunidad, te recomendamos que reportes contenido o cualquier comportamiento que
          consideres que infringe tus derechos (incluidos los derechos de propiedad intelectual) o incumple nuestras
          Condiciones y Políticas.
        </p>
        <h4>
          Los permisos que nos concedes
        </h4>
        <p>
          Para proporcionar nuestros servicios, necesitamos que nos concedas determinados permisos:
        </p>
        <p>
          Permiso para usar contenido que creas y compartes. Es posible que cierto contenido que compartas o subas, como
          fotos e información personal, esté protegido por leyes de propiedad intelectual.
        </p>
        <p>
          Eres el propietario de los derechos de propiedad intelectual de todo el contenido que crees y compartas en
          Aplícate. Ninguna disposición en estas condiciones anula los derechos que tienes sobre tu propio contenido.
          Puedes acceder y eliminar dicho contenido.
        </p>
        <p>

          Sin embargo, para proporcionar nuestro servicio, debes concedernos algunos permisos legales (conocidos como
          "licencias") para usar este contenido. Esto es exclusivamente para proporcionar y mejorar el servicio, como se
          describe anteriormente.
        </p>
        <p>
          En concreto, cuando publicas o subes contenido que se encuentra protegido por derechos de propiedad
          intelectual en Aplícate, nos otorgas una licencia, libre de regalías, sublicenciable, transferible y no
          exclusiva para alojar, usar, distribuir, modificar, publicar, copiar, mostrar o exhibir públicamente tu
          contenido. En otras palabras, si compartes una foto en Aplícate, nos concedes permiso para almacenarla y
          compartirla con usuarios de Aplícate. Esta licencia caduca cuando tu contenido se elimina de nuestros
          sistemas.
        </p>
        <p>
          Puedes eliminar contenido de forma individual. Cuando eliminas contenido, los demás usuarios dejan de verlo.
        </p>
        <p>
          Permiso para actualizar el software que usas o descargas. Si descargas o usas nuestro software, nos concedes
          permiso para descargar e instalar actualizaciones del software, donde corresponda.
        </p>

        <h4>
          Disposiciones adicionales
        </h4>

        <ol>
          <li>
            <h5>
              Actualización de nuestras Condiciones
            </h5>
            <p>
              Trabajamos continuamente para optimizar nuestro servicio y desarrollar nuevas funciones que mejoren a
              Aplícate para ti y nuestra comunidad. Por lo tanto, es posible que, de vez en cuando, debamos actualizar
              estas Condiciones para reflejar con precisión nuestros servicios y prácticas. Solo implementaremos cambios
              si las disposiciones dejan de ser adecuadas o están incompletas, y si dichos cambios son razonables y
              tienen en cuenta tus intereses.
              Una vez que se implementen las actualizaciones de las Condiciones, quedarás sujeto a ellas si continúas
              usando Aplícate.

            </p>
          </li>
          <li>
            <h5>
              Suspensión o cancelación de la cuenta
            </h5>
            <p>
              Queremos que Aplícate sea un lugar donde las personas se sientan bienvenidas y seguras para compartir su
              información.
            </p>
            <p>
              Si determinamos que incumpliste nuestras Condiciones o Políticas en reiteradas oportunidades o de una
              manera notoria o grave, incluidas en particular nuestras normas comunitarias, podemos suspender o
              inhabilitar definitivamente el acceso a tu cuenta. También podemos suspender o inhabilitar tu cuenta si
              infringes reiteradamente los derechos de propiedad intelectual de otras personas o en los casos donde
              estemos obligados a hacerlo por motivos legales.
            </p>
            <p>
              Cuando tomemos tal medida, te avisaremos por medio de correo electrónico especificando los motivos por los
              cuales se inhabilitó tu cuenta.
              Puedes obtener más información dentro de Aplícate sobre cómo ponerte en contacto con nosotros si
              consideras que inhabilitamos tu cuenta por error.
            </p>
          </li>
          <li>
            <h5>
              Límites de responsabilidad
            </h5>
            <p>
              Nos esforzamos por proporcionar el mejor servicio posible y definir pautas claras para todos aquellos que
              usen Aplícate. No obstante, Aplícate se proporciona tal y como está y no podemos garantizar que siempre
              será segura, nunca tendrá errores o funcionará sin interrupciones, demoras o imperfecciones. En la medida
              en que la ley lo permita, también RENUNCIAMOS A TODA GARANTÍA, EXPRESA O IMPLÍCITA, INCLUIDAS LAS
              GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD, IDONEIDAD PARA UN FIN PARTICULAR, TÍTULO Y NO INFRACCIÓN. No
              controlamos ni dirigimos lo que las personas u otros hacen o dicen, ni somos responsables por sus acciones
              o conductas ni por el contenido que comparten, incluido contenido ofensivo, inapropiado, obsceno, ilegal o
              cuestionable.
            </p>
            <p>
              No podemos predecir cuándo puede surgir un problema con Aplícate. En consecuencia, nuestra responsabilidad
              se limitará al máximo alcance que la ley aplicable permita, y bajo ninguna circunstancia seremos
              responsables ante ti por la pérdida de ganancias, ingresos o información, ni por daños consecuentes,
              especiales, indirectos, ejemplares, punitivos o incidentales que surjan a raíz de estas condiciones o los
              servicios de Aplícate, incluso si se nos advirtió sobre la posibilidad de que ocurran dichos daños.
            </p>
          </li>
          <li>
            <h5>
              Disputas
            </h5>
            <p>
              Intentamos imponer reglas claras para poder limitar o, mejor aún, evitar disputas contigo. No obstante, si
              surge alguna disputa, es útil saber con anticipación dónde se puede resolver y qué leyes se aplican.
            </p>
            <p>
              Si eres usuario de Aplícate, las leyes de México se aplicarán a cualquier reclamación, causa o disputa que
              presentes contra nosotros y que surja como consecuencia de estas condiciones o los servicios de Aplícate.
              Asi mismo, puedes resolver la reclamación en cualquier tribunal competente del país que tenga
              jurisdicción. En todos los demás casos, aceptas que la reclamación debe resolverse de forma exclusiva en
              el Tribunal de Sonora. Asi mismo, aceptas someterte a la jurisdicción personal de cualquiera de estos
              tribunales con el propósito de litigar cualquier reclamación y que las leyes del estado de Sonora regirán
              estas Condiciones, así como cualquier reclamación, independientemente de las disposiciones sobre
              conflictos de leyes.
            </p>
          </li>
          <li>
            <h5>
              Otras disposiciones
            </h5>
            <ol>
              <li>
                Estas Condiciones constituyen la totalidad del acuerdo entre tú y Aplícate respecto al uso de nuestro
                servicio y prevalecen sobre cualquier acuerdo anterior.
              </li>
              <li>
                Si se determina que alguna disposición de estas condiciones no se puede ejecutar, las disposiciones
                restantes seguirán en plena vigencia. Si no podemos ejecutar alguna disposición de estas condiciones,
                ello no se considerará una extención de las condiciones. Cualquier modificación o extención de estas
                condiciones debe hacerse por escrito y estar firmada por nosotros.
              </li>
              <li>
                No transferirás ninguno de tus derechos u obligaciones en virtud de estas condiciones a ningún tercero
                sin nuestro consentimiento.
              </li>
              <li>
                Estas condiciones no confieren derechos de beneficiario a ningún tercero. Podemos asignar libremente
                todos nuestros derechos y todas nuestras obligaciones en virtud de estas condiciones en caso de fusión,
                adquisición o venta de activos, por aplicación de la ley o de algún otro modo.
              </li>
              <li>
                Te informamos que es posible que tengamos que cambiar el nombre de usuario de tu cuenta en determinadas
                circunstancias. Por ejemplo, si alguien más reclama el nombre de usuario y no parece guardar relación
                con el nombre que usas en tu vida cotidiana. Te avisaremos con anticipación si tenemos que hacerlo y te
                explicaremos el motivo.
              </li>
              <li>
                Valoramos siempre tus comentarios y cualquier otra sugerencia sobre nuestro servicio. No obstante, te
                informamos que podemos usarlos sin restricción u obligación alguna de brindarte una compensación, y no
                tenemos la obligación de mantenerlos en confidencialidad.
              </li>
              <li>
                Nos reservamos todos los derechos que no te hayamos concedido de forma expresa.
              </li>
            </ol>
          </li>
        </ol>

        <h4>
          Política de datos
        </h4>
        <p>
          En esta Política, se describe la información que tratamos para respaldar a Aplícate.
        </p>
        <h5>
          ¿Qué tipo de información recopilamos?
        </h5>
        <p>
          A fin de proporcionarte los servicios de Aplícate debemos tratar información sobre ti.
        </p>
        <h6>
          Lo que tú y otras personas hacen y proporcionan.
        </h6>
        <p>
          Información y contenido que nos proporcionas. Recopilamos el contenido y otros datos que proporcionas cuando
          usas nuestro servicio. Por ejemplo al registrarte como usuario de Aplícate recopilamos datos como correos
          electrónicos, nombres y apellidos; Al realizar una publicación deberás proporcionar datos como teléfonos,
          direcciones y fotografias.
          Además de que Aplicate solicita el acceso a las galerías de los dispositivos, asi como el uso de la cámara.
        </p>
        <h5>
          ¿Cómo usamos esta información?
        </h5>
        <h6>
          Fomentamos la seguridad, la integridad y la protección.
        </h6>
        <p>
          Usamos la información que tenemos para verificar cuentas y actividades, combatir conductas perjudiciales,
          detectar y prevenir spam y otras experiencias negativas, conservar la integridad de nuestro servicio y
          fomentar la seguridad tanto dentro como fuera de los servicios de Aplícate.
        </p>
        <h6>
          Nos comunicamos contigo.
        </h6>
        <p>
          Usamos la información que tenemos para enviarte mensajes informativos en caso de infringir nuestras políticas
          de comunidad. También usamos tu información para responderte cuando te pones en contacto con nosotros.
        </p>
        <h5>
          ¿Cómo se comparte esta información?
        </h5>
        <h6>
          Tu información se comparte con otros de las siguientes formas:
        </h6>
        <p>
          Cualquier persona puede ver la información pública. La información recopilada de un usuario esta expuesta
          publicamente a todos los demas usuarios de Aplícate, es decir cualquier persona que instale la aplicación
          tendra acceso a los datos que otros usuarios han publicado al ofrecer su servicio o negocio por medio de
          Aplícate.
        </p>
        <h6>
          ¿Cómo puedo administrar o eliminar la información sobre mí?
        </h6>
        <p>
          Por el momento Aplícate no permite que elimines los datos de tu cuenta pero si es posible que como usuario
          elimines cualquier contenido que hayas creado.
        </p>
        <h6>
          ¿Cómo respondemos a solicitudes legales o evitamos daños?
        </h6>
        <p>
          Accedemos a tu información, la conservamos y la compartimos con organismos reguladores, autoridades u otras
          partes en los siguientes casos:
        </p>
        <ul>
          <li>
            En respuesta a un requerimiento legal (como una orden de registro, una orden judicial o una citación) si
            creemos de buena fe que la ley así lo exige. Esto puede incluir responder a requerimientos legales de
            jurisdicciones ajenas a los Estados Unidos Mexicanos si creemos de buena fe que la ley de esa jurisdicción
            exige dicha respuesta, afecta a los usuarios de dicha jurisdicción y resulta consistente con estándares
            reconocidos nacionalmente.
          </li>
          <li>
            Si creemos de buena fe que es necesario para detectar, impedir y abordar casos de fraude, usos no
            autorizados del servicio de Aplícate, incumplimientos de las condiciones o las políticas aplicables, así
            como otras actividades perjudiciales o ilegales; para protegernos (incluidos nuestros derechos, nuestra
            propiedad o nuestro servicio), así como para proteger a ti o a otras personas, también como parte de
            investigaciones o indagaciones reglamentarias; o para evitar la muerte o lesiones físicas inminentes. Por
            ejemplo, en los casos relevantes, intercambiamos información con socios externos sobre la confiabilidad de
            tu cuenta para prevenir fraudes, abusos y otras actividades perjudiciales que se produzcan dentro y fuera de
            nuestro servicio.
          </li>
        </ul>
        <p>
          Podemos acceder a la información que recibamos sobre ti y conservarla durante un período extendido en caso de
          que esté sujeta a un requisito o una obligación legal, una investigación gubernamental o investigaciones
          relacionadas con posibles incumplimientos de nuestras condiciones o políticas, o bien para evitar daños.
          También podemos conservar información sobre las cuentas que se inhabilitaron por incumplir nuestras
          condiciones durante por lo menos un año con el objetivo de evitar que se repitan conductas abusivas o
          incumplimientos de nuestras condiciones.
        </p>
        <h5>
          ¿Cómo te notificaremos sobre los cambios que se efectúen en esta política?
        </h5>
        <p>
          Te notificaremos antes de realizar cambios en ésta política y te daremos la oportunidad de revisar las
          modificaciones antes de seguir usando nuestro servicio.
        </p>
        <p>
          Dicha información sera proporcionada por correo electrónico.
        </p>
        <h5>
          ¿Cómo puedes hacer llegar tus dudas a Aplícate?
        </h5>
        <p>
          Si tienes preguntas sobre ésta política, puedes ponerte en contacto con nosotros como se describe a
          continuación.
        </p>
        <p>
          Contáctanos <br>
          Puedes contactarnos por correo electrónico en la siguiente dirección: <br>
          aplicate.apson@gmail.com <br>
          Agua Prieta Sonora México <br>
          +52 (633)-126-2279
        </p>
        <h4>
          Politica de comunidad
        </h4>
        <ol>
          <li>
            <h5>Violencia e incitación</h5>
            <p>
              Nos esforzamos por prevenir daños en la vida real que puedan estar relacionados con contenido en Aplícate.
              Si bien entendemos que las personas suelen expresar desprecio o desacuerdo mediante amenazas o apelaciones
              a la violencia sin intenciones serias, eliminamos el lenguaje que incita o da lugar a actos graves de
              violencia. En los casos en los que consideramos que existe riesgo real de daños físicos o amenazas
              directas a la seguridad pública, eliminamos el contenido, inhabilitamos las cuentas y colaboramos con las
              autoridades competentes. También intentamos tener en cuenta el lenguaje y el contexto para distinguir
              afirmaciones casuales de contenido que constituya una amenaza creíble a la seguridad pública o privada.
              Para determinar si una amenaza es creíble, también podemos tener en cuenta otros datos, como la
              visibilidad pública y el riesgo para la seguridad física de una persona.
            </p>
            <p>
              En algunos casos, observamos amenazas condicionales o expresiones de deseo dirigidas a terroristas o a
              otras personas violentas (como "Hay que matar a todos los terroristas"), pero las consideramos no creíbles
              ante la ausencia de pruebas que demuestren lo contrario.
            </p>
          </li>
          <li>
            <h5>
              Personas y organizaciones peligrosas
            </h5>
            <p>
              Para evitar y prevenir daños en la vida real, no permitimos la presencia en Aplícate de ninguna persona u
              organización que reivindique una misión violenta o cometa actos de violencia. Esto incluye lo siguiente:
            </p>
            <ul>
              <li>
                Actividades terroristas
              </li>
              <li>
                Odio organizado
              </li>
              <li>
                Asesinato en serie o en masa (lo que incluye intentos de asesinato)
              </li>
              <li>
                Trata de personas
              </li>
              <li>
                Crimen organizado o actividades delictivas
              </li>
            </ul>
            <p>
              También eliminamos el contenido que apoye o elogie a grupos, líderes o personas implicadas en estas
              actividades.
            </p>
          </li>
          <li>
            <h5>
              Publicidad de la delincuencia
            </h5>
            <p>
              Para prevenir y evitar daños y la imitación de dicho comportamiento, no permitimos que las
              personas faciliten, organicen, promocionen o admitan determinadas actividades criminales o dañinas
              dirigidas a personas o negocios.
            </p>
          </li>
          <li>
            <h5>
              Artículos regulados
            </h5>
            <p>
              Para fomentar la seguridad y el cumplimiento de las prohibiciones legales comunes, no permitimos que
              individuos, fabricantes o minoristas compren, vendan o intercambien drogas, fármacos ni marihuana. Tampoco
              permitimos la compra, venta, obsequio, intercambio y traspaso de armas de fuego, incluidas partes o
              municiones, entre personas en Aplícate.
            </p>
          </li>
          <li>
            <h5>
              Fraude y engaño
            </h5>
            <p>
              En un esfuerzo por prevenir e interrumpir actividades dañinas o fraudulentas, eliminamos contenido cuyo
              fin sea engañar intencionalmente a las personas para obtener una ventaja o privar a alguien de dinero,
              propiedades o derechos legales.
            </p>
          </li>
        </ol>
      </div>

    </div>
  </div>
</div>
